import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EuiMenuModule } from '../../../components';
import { EuiButtonModule } from '../../../components';

import { EuiAppSidebarComponent } from './sidebar.component';
import { EuiAppSidebarHeaderComponent } from './sidebar-header/sidebar-header.component';
import { EuiAppSidebarBodyComponent } from './sidebar-body/sidebar-body.component';
import { EuiAppSidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { EuiAppSidebarFooterComponent } from './sidebar-footer/sidebar-footer.component';
import { EuiAppSidebarHeaderUserProfileComponent } from './sidebar-header-user-profile/sidebar-header-user-profile.component';
import { EuiAppSidebarDrawerComponent } from './sidebar-drawer/sidebar-drawer.component';

const COMPONENTS = [
    EuiAppSidebarComponent,
    EuiAppSidebarHeaderComponent,
    EuiAppSidebarBodyComponent,
    EuiAppSidebarFooterComponent,
    EuiAppSidebarMenuComponent,
    EuiAppSidebarHeaderUserProfileComponent,
    EuiAppSidebarDrawerComponent,
];

@NgModule({
    imports: [
        CommonModule, RouterModule,
        EuiMenuModule,
        EuiButtonModule,
    ],
    declarations: [
        ...COMPONENTS,
    ],
    exports: [
        ...COMPONENTS,
    ],
})
export class EuiAppSidebarModule { }
